import React, {useEffect, useState,useContext, useCallback} from "react";
import { useFetch } from "../../api/FetchApiData";
import { ButtonLoader } from "../../utils/Loaders/ButtonLoader";
import { UAParser } from 'ua-parser-js';
import mobile_icon from '../icons/mobile.webp';
import desktop_icon from '../icons/laptop.webp';
import remove_icon from '../../icons/remove.webp';
import { UserContext } from "../../../AppContextProvider";
import { useTranslation } from "react-i18next";


function base64urlToBuffer(base64url){
    base64url = base64url.replace(/-/g, '+').replace(/_/g, '/');
    const padding = (base64url.length % 4);
    if (padding) {
      base64url += '='.repeat(4-padding);
    } 
    const binary = window.atob(base64url);
    const buffer = new ArrayBuffer(binary.length);
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return buffer;
  }

function bufferToBase64url(buffer) {
  return btoa(
    String.fromCharCode(...new Uint8Array(buffer))
  )
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

export async function SignChallenge (web_auth)
{
    let webauthnProof = null;
    const assertion = await navigator.credentials.get({
          publicKey: {
            challenge: base64urlToBuffer(web_auth.challenge),
            allowCredentials: web_auth.allowCredentials.map(cred => ({
              id: base64urlToBuffer(cred.id),
              type: cred.type})),
            rpId: web_auth.rpId,
            userVerification: web_auth.userVerification
          }
        });
    webauthnProof = {
        id: bufferToBase64url(assertion.rawId),
        rawId: bufferToBase64url(assertion.rawId),
        type: assertion.type,
        response: {
            authenticatorData: bufferToBase64url(assertion.response.authenticatorData),
            clientDataJSON: bufferToBase64url(assertion.response.clientDataJSON),
            signature: bufferToBase64url(assertion.response.signature),
            userHandle: assertion.response.userHandle
            ? bufferToBase64url(assertion.response.userHandle)
            : null
      }};
    return webauthnProof
}

function DeviceRegistration({partner,partner_id=null,device=null,owned=false}) {  
  const [options, setOptions] = useState(null);
  const fetchData = useFetch();
  const [devices,setDevices] = useState(null);
  const [loading,setLoading] = useState(false);
  const [UserState,setUserState] = useContext(UserContext);
  const {t} = useTranslation();
   const [btntext,setBtnText] = useState(t("user-info.appareil"));

  useEffect(() => {
    if(!!device)
    {
      setDevices({...devices,saved_device:device});
      return
    }
    const parser = new UAParser();
    const result = parser.getResult();
    const device_info = {
          deviceType: result.device.type || "desktop",
          deviceVendor: result.device.vendor || null,
          deviceModel: result.device.model || null,
          os: `${result.os.name} ${result.os.version}`,
          browser: `${result.browser.name} ${result.browser.version}`,
          cpu: result.cpu.architecture,
          userAgent: result.ua
        };
    setDevices({...devices,current:device_info});
    let data_ = {};
    if (!!partner && !!partner_id)
      data_ = {partner:partner,partner_id:partner_id};
    fetchData.PostData(data_,"device/start/").then(result => {
    if(result.result)
    {
        if(!!result.options && !!result.status && result.status==="started")
          setOptions(result.options);
        else if(!!result.status && result.status==="device_set")
          setDevices({...devices,saved_device:result.device});
        else
        {}   
    }
  });
  }, []);

  useEffect(() => {
    if(!!devices?.saved_device)
    {
      setBtnText(<div>
        {(!!devices.saved_device.vendor) && <label>{devices.saved_device.vendor}</label>}
        {(!!devices.saved_device.deviceType) && <label>{devices.saved_device.deviceType+ ' '}</label>}
        {(!!devices.saved_device.deviceType) && <label>{devices.saved_device.deviceModel}</label>}<br/>
        {(!!devices.saved_device.os) && <label>{devices.saved_device.os}</label>}
      </div>);
    }
  }, [devices?.saved_device]);


  const SavePhone = async () => { 
    if(!!options && !(!!devices.saved_device) && (owned || UserState.is_staff)) 
    {
       
        setLoading(true); 
        options.challenge = base64urlToBuffer(options.challenge);
        options.user.id = base64urlToBuffer(options.user.id);
        navigator.credentials.create({publicKey: options}).then(credential => {
            fetchData.PostData({cred:{
            id: bufferToBase64url(credential.rawId),
            rawId: bufferToBase64url(credential.rawId),
            type: credential.type,
            response: {
                attestationObject: bufferToBase64url(credential.response.attestationObject),
                clientDataJSON: bufferToBase64url(credential.response.clientDataJSON),
            }},device:devices.current},"device/finish/").then(result => {
            if(result.result)
              setDevices({...devices,saved_device:result.device});
            setLoading(false);
        });
          
          }).catch(err => {console.error(err);});

        /**/
    }
  }

  const DeleteDevice = async () => {
    let data_ = {};
    if ((!!partner && !!partner_id) || partner==='staff')
      data_ = {partner:partner,partner_id:partner_id};
    console.log(data_);
    fetchData.DeleteData(data_,"device/delete/").then(resp => {
        console.log(resp);
    });
  }

    return (
    <div style={{width:'100%',height:'50px',margin:'auto',textAlign:'center'}}>
        {(!!devices?.saved_device) && <img src={devices?.saved_device?.deviceType==="mobile"?mobile_icon:desktop_icon} style={{height:'40px',width:'40px',verticalAlign:'middle'}} />}
        <div style={{display:'inline-block',verticalAlign:'middle',width:'60%',height:'100%',marginLeft:'10px'}}>
          <ButtonLoader onSubmit={SavePhone} text={btntext} style={{backGroundColor:'skyblue',color:'black',fontSize:''}} loading={loading} />
        </div>
        {(UserState.is_staff && !!device) && <img onClick={e=>{DeleteDevice()}} src={remove_icon} style={{height:'35px',width:'35px',verticalAlign:'middle',marginLeft:'10px'}} />}
    </div>
  );
}
export default DeviceRegistration